import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import LABELESPECIAL from '../../../business-const/Label/LabelEspecial'

import MESSAGE from '../../../business-const/Message/Message'

import {
    formataTableCellHeadExibeDadosTitulo,
    formataTableCellHeadExibeDadosValor,
    formataTableCellHeadExibeDadosValorQuebraEspecial,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
    formataEstudoProjecaoSucessaoVitalicia,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    CardGridEstudoPadrao,
} from './EstudoComp'



const EstudoFormProjecaoSucessaoVitalicia = ( { values, estudo, report, indInicial, indFinal, popup } ) => {

    const ProjecaoSucessaoVitalicia = () => {

        let headList = [
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTitulo(
                    LABELESPECIAL.ano.charAt(0).toUpperCase() + LABELESPECIAL.ano.substring(1), report),
            },
            {
                colSpan: 3,
                headTitle: formataTableCellHeadExibeDadosTitulo(LABEL.idade, report),
            },
        ]

        if (values.emergencial) {

            headList.push(
                {
                    colSpan: 5,
                    headTitle: formataTableCellHeadExibeDadosValor(LABEL.emergencial, report),
                },
            )
        }

        headList.push(
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.patrimonioImobilizado, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.recursosFinanceiros, report),
            },
            {
                colSpan: 5,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.sucessaoVitalicia, report),
            },
        )

        if (dadosCompletosCliente(values)) {

            headList.push(
                {
                    colSpan: 5,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                    LABEL.sucessaoVitalicia + "<br/>" + tituloCliente(values), report
                                ),
                },
            )
        }

        if (dadosCompletosConjuge(values)) {

            headList.push(
                {
                    colSpan: 5,
                    headTitle: formataTableCellHeadExibeDadosValorQuebraEspecial(
                                LABEL.sucessaoVitalicia + "<br/>" + tituloConjuge(values), report
                            ),
                },
            )
        }


        
        return (
            <>
                <TableExibeDados
                    report={report}
                >
                    <TableHeadExibeDados
                        report={report}
                        //popup={popup}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {estudo.current.tabelaProjecaoSucessaoVitalicia?.map((item, ind) => {

                            let colSpan = 0

                            return (!indFinal || (ind >= indInicial && ind <= indFinal)) && (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                        primeiraColuna={true}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.ano, report, false)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.idade, report, false)}
                                    </TableCellBodyExibeDados>

                                    {values.emergencial > 0 && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.emergencial, report, false, true)}
                                        </TableCellBodyExibeDados>
                                    )}

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.inventarioPatrimonioImobilizado,
                                            report, false, true)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.inventarioRecursosFinanceiros,
                                            report, false, true)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[colSpan++].colSpan}
                                    >
                                        {formataTableCellBodyExibeDadosValor(item.sucessaoVitalicia,
                                            report, false, true)}
                                    </TableCellBodyExibeDados>

                                    {dadosCompletosCliente(values) && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.sucessaoVitaliciaCliente,
                                                report, false, true)}
                                        </TableCellBodyExibeDados>
                                    )}

                                    {dadosCompletosConjuge(values) && (
                                        <TableCellBodyExibeDados
                                            colSpan={headList[colSpan++].colSpan}
                                        >
                                            {formataTableCellBodyExibeDadosValor(item.sucessaoVitaliciaConjuge,
                                                report, false, true)}
                                        </TableCellBodyExibeDados>
                                    )}
                                </TableRowBodyExibeDados>
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>

                {(!indFinal || indFinal >= estudo.current.tabelaProjecaoSucessaoVitalicia.length - 1) && (
                    <GridItem12
                        className='mt-10 mb-5'
                        align='center'
                    >
                        {formataEstudoProjecaoSucessaoVitalicia(
                            MESSAGE().projecaoSucessaoVitalicia
                        )}
                    </GridItem12>
                )}
            </>
        )
    }

    return (
        report
            ?
                <GridContainer
                    className={(indInicial === 0 ? 'mt--8' : '') + ' ml-13'}
                >
                    <GridItem10>
                        <ProjecaoSucessaoVitalicia />
                    </GridItem10>
                </GridContainer>
            :
                <CardGridEstudoPadrao
                    label={LABEL.receitaMensal}
                    component={<ProjecaoSucessaoVitalicia/>}
                    overflowX={true}
                    popup={popup}
                />
    )
}

export default EstudoFormProjecaoSucessaoVitalicia